import { Component, viewChild } from '@angular/core';
import { SynAlertComponent, SynIconComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-saved-toast',
  template: `
    <syn-alert variant="success" [duration]="5000" closable="" #alert>
      <syn-icon slot="icon" name="check_circle_fill" />
      <strong i18n="@@changes-saved">Your changes have been saved.</strong>
    </syn-alert>`,
  styles: [],
  imports: [
    SynAlertComponent,
    SynIconComponent,
  ],
})
export class SavedToastComponent {
  alert = viewChild<SynAlertComponent>('alert');

  public toast() {
    void this.alert()?.nativeElement?.toast();
  }
}
